import { useEffect, useState } from "react";
import {
  getLogarithmicProgress,
  PROGRESS_INTERVAL_MS,
} from "./constants";
import { ProofOfAddressValidationLoader } from "./ProofOfAddressValidationLoader";

interface ProofOfAddressProcessingLoaderProps {
  readonly documentType?: string;
}

export function ProofOfAddressProcessingLoader({
  documentType,
}: ProofOfAddressProcessingLoaderProps) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startedAt = Date.now();
    const intervalId = window.setInterval(() => {
      setProgress(getLogarithmicProgress(Date.now() - startedAt));
    }, PROGRESS_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <div className="w-full flex items-center justify-center min-h-[60vh]">
      <ProofOfAddressValidationLoader
        progress={progress}
        documentType={documentType}
      />
    </div>
  );
}
